const login = {
  path: '',
  component: resolve => require(['../../../../pages/home/user/login'], resolve)
}

export default login



// WEBPACK FOOTER //
// ./src/router/home/user/login/index.js